import { Modal } from "react-bootstrap";
import { ACTION_TYPE, REPORT_NAME } from "../constant/reportType";
import { Form, Formik } from "formik";
import { useDispatch } from "react-redux";
import { alertMessage } from "../../utils/AlertService";
import { useEffect, useState } from "react";
import Loading from "../Loading";
import { getLocalStorageData } from "../../utils/LocalStorageService";
import { useGetAllVoucherTypeFinanceMasterListMutation, useGetVoucherTypeFinanceMasterByIdMutation, useSaveVoucherTypeFinanceMasterMutation, useUpdateVoucherTypeFinanceMasterMutation, useUploadBulkVoucherTypeFinanceMasterMutation } from "../../redux-toolkit/services/voucherTypeFinanceMasterService";
import { useGetAllVoucherTypeKarmaMasterListMutation, useGetVoucherTypeKarmaMasterByIdMutation, useSaveVoucherTypeKarmaMasterMutation, useUpdateVoucherTypeKarmaMasterMutation, useUploadBulkVoucherTypeKarmaMasterMutation } from "../../redux-toolkit/services/voucherTypeKarmaMasterService";
import { useBulkUploadVoucherFinanceMutation, useFindAllVoucherFinanceMutation, useGetVoucherFinanceByIdMutation, useSaveVoucherFinanceMutation, useUpdateVoucherFinanceMutation } from "../../redux-toolkit/services/voucherFinanceService";
import { useBulkUploadVoucherKarmaMutation, useGetVoucherKarmaByIdMutation, useSaveVoucherKarmaMutation, useUpdateVoucherKarmaMutation } from "../../redux-toolkit/services/voucherKarmaService";
import { useFindAllScenarioMastersMutation } from "../../redux-toolkit/services/scenarioMasterService";
import { useGetAllAccountMutation } from "../../redux-toolkit/services/accountMasterService";
import { useFindAllScripturalReferencesMutation } from "../../redux-toolkit/services/scripturalReferenceMasterService";
import { getAllScenarioMasterList, setAllScenarioMasters } from "../../redux-toolkit/slices/scenarioMasterSlice";
import { useAppSelector } from "../../redux-toolkit/hooks";
import { getVoucherTypeFinanceMasterList, setAllVoucherTypeFinanceMaster } from "../../redux-toolkit/slices/voucherTypeFinanceMasterSlice";
import { getVoucherTypeKarmaMasterList, setAllVoucherTypeKarmaMaster } from "../../redux-toolkit/slices/voucherTypeKarmaMasterSlice";
import { getAllAccountMasterList, setAllAccountMaster } from "../../redux-toolkit/slices/accountMasterSlice";
import { getAllScripturalReferenceList, setAllScripturalReferences } from "../../redux-toolkit/slices/scripturalReferenceMasterSlice";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import { getAllVoucherFinanceList, setAllVoucherFinance } from "../../redux-toolkit/slices/voucherFinanceSlice";
import { useBulkSaveVoucherParticipantMutation, useGetVoucherParticipantByIdMutation, useSaveVoucherParticipantMutation, useUpdateVoucherParticipantMutation } from "../../redux-toolkit/services/voucherParticipantService";
import { useFindAllMemberMasterMasterMutation } from "../../redux-toolkit/services/MemberMasterService";
import { getMemberMasterList, setMemberMasterList } from "../../redux-toolkit/slices/memberMasterSlice";
import { useBulkSaveAuditLogMutation, useSaveAuditLogMutation } from "../../redux-toolkit/services/auditLogService";
import { useBulkSavePartyCategoryMasterMutation, useFindAllPartyCategoryMasterMutation, useGetPartyCategoryMasterByIdMutation, useSavePartyCategoryMasterMutation, useUpdatePartyCategoryMasterMutation } from "../../redux-toolkit/services/partyCategoryMasterService";
import { getPartyCategoryMasterList, setAllPartyCategoryMaster } from "../../redux-toolkit/slices/partyCategoryMasterSlice";

type Props = {
    show: boolean;
    setShow: any;
    actionType: ACTION_TYPE;
    reportName: string;
    data: any;
    setCall: any;
};

const VoucherTransactionReportData = (props: Props) => {

    const localUserObj: any = getLocalStorageData("localUser");
    const dispatch = useDispatch();

    //states
    const [getByIdData, setGetByIdData]: any = useState([]);
    const [file, setFile]: any = useState<File | null>(null);
    const [activeTab, setActiveTab] = useState<"manual" | "bulk">("manual");


    //save
    const [saveVoucherTypeFinanceMaster, saveVoucherTypeFinanceMasterResponse] = useSaveVoucherTypeFinanceMasterMutation();
    const [saveVoucherTypeKarmaMaster, saveVoucherTypeKarmaMasterResponse] = useSaveVoucherTypeKarmaMasterMutation();
    const [saveVoucherFinanceMaster, saveVoucherFinanceMasterResponse] = useSaveVoucherFinanceMutation();
    const [saveVoucherKarmaMaster, saveVoucherKarmaMasterResponse] = useSaveVoucherKarmaMutation();
    const [saveVoucherParticipanMaster, saveVoucherParticipanMasterResponse] = useSaveVoucherParticipantMutation();
    const [savePartyCategoryMaster, savePartyCategoryMasterResponse] = useSavePartyCategoryMasterMutation();
    const [logAudit] = useSaveAuditLogMutation();
    const [logAuditBulk] = useBulkSaveAuditLogMutation();
    //bulk
    const [bulkSaveVoucherTypeFinanceMaster, bulkSaveVoucherTypeFinanceMasterResponse] = useUploadBulkVoucherTypeFinanceMasterMutation();
    const [bulkSaveVoucherTypeKarmaMaster, bulkSaveVoucherTypeKarmaMasterResponse] = useUploadBulkVoucherTypeKarmaMasterMutation();
    const [bulkSaveVoucherFinanceMaster, bulkSaveVoucherFinanceMasterResponse] = useBulkUploadVoucherFinanceMutation();
    const [bulkSaveVoucherKarmaMaster, bulkSaveVoucherKarmaMasterResponse] = useBulkUploadVoucherKarmaMutation();
    const [bulkSaveVoucherParticipanMaster, bulkSaveVoucherParticipanMasterResponse] = useBulkSaveVoucherParticipantMutation();
    const [bulkSavePartyCategoryMaster, bulkSavePartyCategoryMasterResponse] = useBulkSavePartyCategoryMasterMutation();
    //update
    const [updateVoucherTypeFinanceMaster, updateVoucherTypeFinanceMasterResponse] = useUpdateVoucherTypeFinanceMasterMutation();
    const [updateVoucherTypeKarmaMaster, updateVoucherTypeKarmaMasterResponse] = useUpdateVoucherTypeKarmaMasterMutation();
    const [updateVoucherFinanceMaster, updateVoucherFinanceMasterResponse] = useUpdateVoucherFinanceMutation();
    const [updateVoucherKarmaMaster, updateVoucherKarmaMasterResponse] = useUpdateVoucherKarmaMutation();
    const [updateVoucherParticipanMaster, updateVoucherParticipanMasterResponse] = useUpdateVoucherParticipantMutation();
    const [updatePartyCategoryMaster, updatePartyCategoryMasterResponse] = useUpdatePartyCategoryMasterMutation();

    //getById mutation
    const [getVoucherTypeFinanceMasterById, voucherTypeFinanceMasterByIdResponse] = useGetVoucherTypeFinanceMasterByIdMutation();
    const [getVoucherTypeKarmaMasterById, VoucherTypeKarmaMasterByIdResponse] = useGetVoucherTypeKarmaMasterByIdMutation();
    const [getVoucherFinanceMasterById, voucherFinanceMasterByIdResponse] = useGetVoucherFinanceByIdMutation();
    const [getVoucherKarmaMasterById, voucherKarmaMasterByIdResponse] = useGetVoucherKarmaByIdMutation();
    const [getVoucherParticipanMasterById, voucherParticipanMasterByIdResponse] = useGetVoucherParticipantByIdMutation();
    const [getPartyCategoryMasterById, partyCategoryMasterMasterByIdResponse] = useGetPartyCategoryMasterByIdMutation();

    //getAllData
    const [findAllScenarioMasters, findAllScenarioMastersResponse] = useFindAllScenarioMastersMutation();
    const [getAllVoucherTypeFinanceMaster, getAllVoucherTypeFinanceMasterResponse] = useGetAllVoucherTypeFinanceMasterListMutation();
    const [getAllVoucherTypeKarmaMaster, getAllVoucherTypeKarmaMasterResponse] = useGetAllVoucherTypeKarmaMasterListMutation();
    const [findAllAccountMaster, findAllAccountMasterResponse] = useGetAllAccountMutation();
    const [findAllScripturalReferences, findAllScripturalReferencesResponse] = useFindAllScripturalReferencesMutation();
    const [findAllVoucherFinance, findAllVoucherFinanceResponse] = useFindAllVoucherFinanceMutation();
    const [findAllMemberMaster, findAllMemberMasterResponse] = useFindAllMemberMasterMasterMutation();
    const [findAllPartyCategoryMaster, findAllPartyCategoryMasterResponse] = useFindAllPartyCategoryMasterMutation();

    //Data
    const allScenarioMasterData: any = useAppSelector(getAllScenarioMasterList);
    const allVoucherTypeFinanceMasterData: any = useAppSelector(getVoucherTypeFinanceMasterList);
    const allVoucherTypeKarmaMasterData: any = useAppSelector(getVoucherTypeKarmaMasterList);
    const allAccountMasterData: any = useAppSelector(getAllAccountMasterList);
    const allScripturalReferencesData: any = useAppSelector(getAllScripturalReferenceList);
    const allVoucherFinanceData: any = useAppSelector(getAllVoucherFinanceList);
    const allMemberMasterData: any = useAppSelector(getMemberMasterList);
    const allPartyCategoryData: any = useAppSelector(getPartyCategoryMasterList);


    useEffect(() => {
        if (props.actionType === ACTION_TYPE.UPDATE_ACTION) {
            if (props.reportName === REPORT_NAME.VOUCHER_TYPE_MASTER_FINANCE) {
                getVoucherTypeFinanceMasterById({
                    id: props?.data?.id,
                    token: localUserObj?.token
                });
            } else if (props.reportName === REPORT_NAME.VOUCHER_TYPE_MASTER_KARMA) {
                getVoucherTypeKarmaMasterById({
                    id: props?.data?.id,
                    token: localUserObj?.token
                });
            }
            else if (props.reportName === REPORT_NAME.VOUCHER_FINANCE) {
                getVoucherFinanceMasterById({
                    id: props?.data?.id,
                    token: localUserObj?.token
                });
                findAllAccountMaster({ token: localUserObj?.token });
                getAllVoucherTypeFinanceMaster({ token: localUserObj?.token });
                findAllPartyCategoryMaster({ token: localUserObj?.token })

            }
            else if (props.reportName === REPORT_NAME.VOUCHER_KARMA) {
                getVoucherKarmaMasterById({
                    id: props?.data?.id,
                    token: localUserObj?.token
                });
                getAllVoucherTypeKarmaMaster({
                    token: localUserObj?.token
                });
                findAllScenarioMasters({
                    token: localUserObj?.token
                });
                findAllAccountMaster({
                    token: localUserObj?.token
                });
                findAllScripturalReferences({
                    token: localUserObj?.token
                });
                findAllVoucherFinance({
                    token: localUserObj?.token
                })
                // getAllVoucherTypeFinanceMaster({ token: localUserObj?.token });

            }
            else if (props.reportName === REPORT_NAME.VOUCHER_PARTICIPANT) {
                getVoucherParticipanMasterById({
                    id: props?.data?.id,
                    token: localUserObj?.token
                });

                findAllVoucherFinance({
                    token: localUserObj?.token
                })

                findAllMemberMaster({
                    token: localUserObj?.token
                })

            }
            else if (props.reportName === REPORT_NAME.PARTY_CATEGORY_MASTER) {
                getPartyCategoryMasterById({
                    id: props?.data?.id,
                    token: localUserObj?.token
                });
            }
        } else if (props.actionType === ACTION_TYPE.ADD_ACTION) {

            if (props.reportName === REPORT_NAME.VOUCHER_FINANCE) {
                getAllVoucherTypeFinanceMaster({ token: localUserObj?.token });
                findAllPartyCategoryMaster({ token: localUserObj?.token })
                findAllAccountMaster({ token: localUserObj?.token });

            } else if (props.reportName === REPORT_NAME.VOUCHER_KARMA) {
                getAllVoucherTypeKarmaMaster({
                    token: localUserObj?.token
                });
                findAllScenarioMasters({
                    token: localUserObj?.token
                });
                findAllAccountMaster({
                    token: localUserObj?.token
                });
                findAllScripturalReferences({
                    token: localUserObj?.token
                });
                findAllVoucherFinance({
                    token: localUserObj?.token
                })
                // getAllVoucherTypeFinanceMaster({ token: localUserObj?.token });
            }
            else if (props.reportName === REPORT_NAME.VOUCHER_PARTICIPANT) {
                findAllVoucherFinance({
                    token: localUserObj?.token
                })

                findAllMemberMaster({
                    token: localUserObj?.token
                })

            }

        }
    }, [props.reportName]);

    const handleClose = () => {
        props.setShow(false);
    };


    const handleSubmit = (values: any) => {
        if (props.actionType === ACTION_TYPE.ADD_ACTION) {

            if (props.reportName === REPORT_NAME.VOUCHER_TYPE_MASTER_FINANCE) {

                const payload = {
                    name: values.name,
                    description: values.description,
                    isActive: values.isActive,
                }

                saveVoucherTypeFinanceMaster({
                    token: localUserObj?.token,
                    payload: payload,
                });
            } else if (props.reportName === REPORT_NAME.VOUCHER_TYPE_MASTER_KARMA) {

                const payload = {
                    name: values.name,
                    description: values.description,
                    isActive: values.isActive,
                }

                saveVoucherTypeKarmaMaster({
                    token: localUserObj?.token,
                    payload: payload,
                });
            }
            else if (props.reportName === REPORT_NAME.VOUCHER_FINANCE) {

                const payload = {
                    voucherTypeCode: values.voucherTypeCode,
                    amount: values.amount,
                    partyCategoryId: values.partyCategoryId,
                    narration: values.narration,
                    approvalStatus: values.approvalStatus,
                    approvedBy: values.approvedBy,
                    approvalDate: values.approvalDate,
                    party: values.party,
                    parentVoucherCode: values.parentVoucherCode,
                    projectTag: values.projectTag,
                    accountNameDebit: values.accountNameDebit,
                    accountNameCredit: values.accountNameCredit,
                    googleDriveLink: values.googleDriveLink,
                    isActive: values.isActive,
                }

                saveVoucherFinanceMaster({
                    token: localUserObj?.token,
                    payload: payload,
                });
            }

            else if (props.reportName === REPORT_NAME.VOUCHER_KARMA) {

                const payload = {
                    voucherTypeCode: values.voucherTypeCode,
                    scenarioId: values.scenarioId,
                    accountId: values.accountId,
                    debit: values.debit,
                    credit: values.credit,
                    tokenValue: values.tokenValue,
                    agent: values.agent,
                    assessmentOutcome: values.assessmentOutcome,
                    improvementSuggestion: values.improvementSuggestion,
                    aiConfidenceScore: values.aiConfidenceScore,
                    scripturalReferenceId: values.scripturalReferenceId,
                    parentVoucherId: values.parentVoucherId,
                    purposeCode: values.purposeCode,
                    validityDate: values.validityDate,
                    projectTag: values.projectTag,
                    isActive: values.isActive,
                    scriptureVerseName: values.scriptureVerseName,
                    verseExplanation: values.verseExplanation,
                    scripturalReferenceCode: values.scripturalReferenceCode,
                    scenarioCode: values.scenarioCode,
                    accountCode: values.accountCode,

                }

                saveVoucherKarmaMaster({
                    token: localUserObj?.token,
                    payload: payload,
                });
            }
            else if (props.reportName === REPORT_NAME.VOUCHER_PARTICIPANT) {

                const payload = {
                    voucherId: values.voucherId,
                    memberId: values.memberId,
                    role: values.role,
                    memberCode: values.memberCode,
                    isActive: values.isActive,
                }

                saveVoucherParticipanMaster({
                    token: localUserObj?.token,
                    payload: payload,
                });
            }

            else if (props.reportName === REPORT_NAME.PARTY_CATEGORY_MASTER) {
                const payload = {
                    code: values.code,
                    name: values.name,
                    description: values.description,
                    isActive: values.isActive
                };

                savePartyCategoryMaster({
                    token: localUserObj?.token,
                    payload: payload,
                });
            }

        } else if (props.actionType === ACTION_TYPE.UPDATE_ACTION) {
            if (props.reportName === REPORT_NAME.VOUCHER_TYPE_MASTER_FINANCE) {

                const payload = {
                    id: props?.data?.id,
                    name: values.name,
                    description: values.description,
                    memberCode: values.memberCode,
                    isActive: true,

                }
                updateVoucherTypeFinanceMaster({
                    token: localUserObj?.token,
                    payload: payload,
                    id: props?.data?.id,
                });
            } else if (props.reportName === REPORT_NAME.VOUCHER_TYPE_MASTER_KARMA) {

                const payload = {
                    id: props?.data?.id,
                    name: values.name,
                    description: values.description,
                    isActive: true,
                }

                updateVoucherTypeKarmaMaster({
                    token: localUserObj?.token,
                    payload: payload,
                    id: props?.data?.id,
                });
            }

            else if (props.reportName === REPORT_NAME.VOUCHER_FINANCE) {

                const payload = {
                    id: values.id,
                    voucherTypeCode: values.voucherTypeCode,
                    amount: values.amount,
                    partyCategoryId: values.partyCategoryId,
                    narration: values.narration,
                    approvalStatus: values.approvalStatus,
                    approvedBy: values.approvedBy,
                    party: values.party,
                    approvalDate: values.approvalDate,
                    parentVoucherCode: values.parentVoucherCode,
                    projectTag: values.projectTag,
                    accountNameDebit: values.accountNameDebit,
                    accountNameCredit: values.accountNameCredit,
                    googleDriveLink: values.googleDriveLink,
                    isActive: values.isActive,
                }

                updateVoucherFinanceMaster({
                    token: localUserObj?.token,
                    payload: payload,
                    id: props?.data?.id,
                });
            }

            else if (props.reportName === REPORT_NAME.VOUCHER_KARMA) {

                const payload = {
                    id: props?.data?.id,
                    voucherTypeCode: values.voucherTypeCode,
                    scenarioId: values.scenarioId,
                    accountId: values.accountId,
                    debit: values.debit,
                    credit: values.credit,
                    tokenValue: values.tokenValue,
                    agent: values.agent,
                    assessmentOutcome: values.assessmentOutcome,
                    improvementSuggestion: values.improvementSuggestion,
                    aiConfidenceScore: values.aiConfidenceScore,
                    scripturalReferenceId: values.scripturalReferenceId,
                    parentVoucherId: values.parentVoucherId,
                    purposeCode: values.purposeCode,
                    validityDate: values.validityDate,
                    projectTag: values.projectTag,
                    isActive: values.isActive,
                    scriptureVerseName: values.scriptureVerseName,
                    verseExplanation: values.verseExplanation,
                    scripturalReferenceCode: values.scripturalReferenceCode,
                    scenarioCode: values.scenarioCode,
                    accountCode: values.accountCode,
                }

                updateVoucherKarmaMaster({
                    token: localUserObj?.token,
                    payload: payload,
                    id: props?.data?.id,
                });
            }

            else if (props.reportName === REPORT_NAME.VOUCHER_PARTICIPANT) {

                const payload = {
                    id: props?.data?.id,
                    voucherId: values.voucherId,
                    memberId: values.memberId,
                    role: values.role,
                    isActive: values.isActive,
                }

                updateVoucherParticipanMaster({
                    id: props?.data?.id,
                    token: localUserObj?.token,
                    payload: payload,
                });
            }
            else if (props.reportName === REPORT_NAME.PARTY_CATEGORY_MASTER) {
                const payload = {
                    id: values.id || null,
                    code: values.code,
                    name: values.name,
                    description: values.description,
                    isActive: values.isActive,
                }

                updatePartyCategoryMaster({
                    id: props?.data?.id,
                    token: localUserObj?.token,
                    payload: payload,
                });
            }
        }
    };


    useEffect(() => {
        if (saveVoucherTypeFinanceMasterResponse.isSuccess) {
            const response: any = saveVoucherTypeFinanceMasterResponse.data;

            const payload = {
                tableName: REPORT_NAME.VOUCHER_TYPE_MASTER_FINANCE,
                recordId: response?.id,
                operationType: "SAVE",
                newValue: response,
            };

            logAudit({
                token: localUserObj?.token,
                payload: payload,
            });
            alertMessage("Voucher Type Master - Finance added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (saveVoucherTypeFinanceMasterResponse.isError) {
            const response: any = saveVoucherTypeFinanceMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [
        saveVoucherTypeFinanceMasterResponse.isSuccess,
        saveVoucherTypeFinanceMasterResponse.isError
    ]);


    useEffect(() => {
        if (saveVoucherTypeKarmaMasterResponse.isSuccess) {
            const response: any = saveVoucherTypeKarmaMasterResponse.data;

            const payload = {
                tableName: REPORT_NAME.VOUCHER_TYPE_MASTER_FINANCE,
                recordId: response?.id,
                operationType: "SAVE",
                newValue: response,
            };

            logAudit({
                token: localUserObj?.token,
                payload: payload,
            });
            alertMessage("Voucher Type Master - Karma added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (saveVoucherTypeKarmaMasterResponse.isError) {
            const response: any = saveVoucherTypeKarmaMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [
        saveVoucherTypeKarmaMasterResponse.isSuccess,
        saveVoucherTypeKarmaMasterResponse.isError
    ]);


    useEffect(() => {
        if (updateVoucherTypeFinanceMasterResponse.isSuccess) {
            const response: any = updateVoucherTypeFinanceMasterResponse.data;

            const payload = {
                tableName: REPORT_NAME.VOUCHER_TYPE_MASTER_FINANCE,
                recordId: props?.data?.id,
                operationType: "UPDATE",
                oldValue: voucherTypeFinanceMasterByIdResponse?.data,
                newValue: response,
            };

            logAudit({
                token: localUserObj?.token,
                payload: payload,
            });
            alertMessage("Voucher Type Master - Finance updated successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (updateVoucherTypeFinanceMasterResponse.isError) {
            const response: any = updateVoucherTypeFinanceMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [
        updateVoucherTypeFinanceMasterResponse.isSuccess,
        updateVoucherTypeFinanceMasterResponse.isError
    ]);

    useEffect(() => {
        if (updateVoucherTypeKarmaMasterResponse.isSuccess) {
            const response: any = updateVoucherTypeKarmaMasterResponse.data;

            const payload = {
                tableName: REPORT_NAME.VOUCHER_TYPE_MASTER_FINANCE,
                recordId: props?.data?.id,
                operationType: "UPDATE",
                oldValue: VoucherTypeKarmaMasterByIdResponse?.data,
                newValue: response,
            };

            logAudit({
                token: localUserObj?.token,
                payload: payload,
            });
            alertMessage("Voucher Type Master - Karma updated successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (updateVoucherTypeKarmaMasterResponse.isError) {
            const response: any = updateVoucherTypeKarmaMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [
        updateVoucherTypeKarmaMasterResponse.isSuccess,
        updateVoucherTypeKarmaMasterResponse.isError
    ]);


    // Save Voucher Finance
    useEffect(() => {
        if (saveVoucherFinanceMasterResponse.isSuccess) {
            const response: any = saveVoucherFinanceMasterResponse.data;

            const payload = {
                tableName: REPORT_NAME.VOUCHER_TYPE_MASTER_FINANCE,
                recordId: response?.id,
                operationType: "SAVE",
                newValue: response,
            };

            logAudit({
                token: localUserObj?.token,
                payload: payload,
            });
            alertMessage("Voucher Finance Master added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (saveVoucherFinanceMasterResponse.isError) {
            const response: any = saveVoucherFinanceMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [
        saveVoucherFinanceMasterResponse.isSuccess,
        saveVoucherFinanceMasterResponse.isError
    ]);

    // Save Voucher Karma
    useEffect(() => {
        if (saveVoucherKarmaMasterResponse.isSuccess) {
            const response: any = saveVoucherKarmaMasterResponse.data;

            const payload = {
                tableName: REPORT_NAME.VOUCHER_TYPE_MASTER_FINANCE,
                recordId: response?.id,
                operationType: "SAVE",
                newValue: response,
            };

            logAudit({
                token: localUserObj?.token,
                payload: payload,
            });
            alertMessage("Voucher Karma Master added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (saveVoucherKarmaMasterResponse.isError) {
            const response: any = saveVoucherKarmaMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [
        saveVoucherKarmaMasterResponse.isSuccess,
        saveVoucherKarmaMasterResponse.isError
    ]);


    useEffect(() => {
        if (saveVoucherParticipanMasterResponse.isSuccess) {
            const response: any = saveVoucherParticipanMasterResponse.data;

            const payload = {
                tableName: REPORT_NAME.VOUCHER_PARTICIPANT,
                recordId: response?.id,
                operationType: "SAVE",
                newValue: response,
            };

            logAudit({
                token: localUserObj?.token,
                payload: payload,
            });
            alertMessage("Voucher Participant Master added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (saveVoucherParticipanMasterResponse.isError) {
            const response: any = saveVoucherParticipanMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [
        saveVoucherParticipanMasterResponse.isSuccess,
        saveVoucherParticipanMasterResponse.isError
    ]);


    useEffect(() => {
        if (savePartyCategoryMasterResponse.isSuccess) {
            const response: any = savePartyCategoryMasterResponse.data;

            const payload = {
                tableName: REPORT_NAME.PARTY_CATEGORY_MASTER,
                recordId: response?.id,
                operationType: "SAVE",
                newValue: response,
            };

            logAudit({
                token: localUserObj?.token,
                payload: payload,
            });
            alertMessage("Party Category Master added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (savePartyCategoryMasterResponse.isError) {
            const response: any = savePartyCategoryMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [
        savePartyCategoryMasterResponse.isSuccess,
        savePartyCategoryMasterResponse.isError
    ]);

    // Update Voucher Finance
    useEffect(() => {
        if (updateVoucherFinanceMasterResponse.isSuccess) {
            const response: any = updateVoucherFinanceMasterResponse.data;

            const payload = {
                tableName: REPORT_NAME.VOUCHER_TYPE_MASTER_FINANCE,
                recordId: props?.data?.id,
                operationType: "UPDATE",
                oldValue: voucherFinanceMasterByIdResponse?.data,
                newValue: response,
            };

            logAudit({
                token: localUserObj?.token,
                payload: payload,
            });
            alertMessage("Voucher Finance Master updated successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (updateVoucherFinanceMasterResponse.isError) {
            const response: any = updateVoucherFinanceMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [
        updateVoucherFinanceMasterResponse.isSuccess,
        updateVoucherFinanceMasterResponse.isError
    ]);

    // Update Voucher Karma
    useEffect(() => {
        if (updateVoucherKarmaMasterResponse.isSuccess) {
            const response: any = updateVoucherKarmaMasterResponse.data;

            const payload = {
                tableName: REPORT_NAME.VOUCHER_TYPE_MASTER_FINANCE,
                recordId: props?.data?.id,
                operationType: "UPDATE",
                oldValue: voucherKarmaMasterByIdResponse?.data,
                newValue: response,
            };

            logAudit({
                token: localUserObj?.token,
                payload: payload,
            });

            alertMessage("Voucher Karma Master updated successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (updateVoucherKarmaMasterResponse.isError) {
            const response: any = updateVoucherKarmaMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [
        updateVoucherKarmaMasterResponse.isSuccess,
        updateVoucherKarmaMasterResponse.isError
    ]);


    useEffect(() => {
        if (updateVoucherParticipanMasterResponse.isSuccess) {
            const response: any = updateVoucherParticipanMasterResponse.data;

            const payload = {
                tableName: REPORT_NAME.VOUCHER_PARTICIPANT,
                recordId: props?.data?.id,
                operationType: "UPDATE",
                oldValue: voucherKarmaMasterByIdResponse?.data,
                newValue: response,
            };

            logAudit({
                token: localUserObj?.token,
                payload: payload,
            });

            alertMessage("Voucher Participant Master updated successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (updateVoucherParticipanMasterResponse.isError) {
            const response: any = updateVoucherParticipanMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [
        updateVoucherParticipanMasterResponse.isSuccess,
        updateVoucherParticipanMasterResponse.isError
    ]);



    useEffect(() => {
        if (updatePartyCategoryMasterResponse.isSuccess) {
            const response: any = updatePartyCategoryMasterResponse.data;

            const payload = {
                tableName: REPORT_NAME.PARTY_CATEGORY_MASTER,
                recordId: props?.data?.id,
                operationType: "UPDATE",
                oldValue: voucherKarmaMasterByIdResponse?.data,
                newValue: response,
            };

            logAudit({
                token: localUserObj?.token,
                payload: payload,
            });

            alertMessage("Party Category Master updated successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (updatePartyCategoryMasterResponse.isError) {
            const response: any = updatePartyCategoryMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [
        updatePartyCategoryMasterResponse.isSuccess,
        updatePartyCategoryMasterResponse.isError
    ]);




    useEffect(() => {
        if (voucherTypeFinanceMasterByIdResponse.isSuccess) {
            setGetByIdData(voucherTypeFinanceMasterByIdResponse.data);
        } else if (voucherTypeFinanceMasterByIdResponse.isError) {
            let response: any = voucherTypeFinanceMasterByIdResponse?.error;
            alertMessage(response, "error");
        }
    }, [voucherTypeFinanceMasterByIdResponse.isSuccess, voucherTypeFinanceMasterByIdResponse.isError]);

    useEffect(() => {
        if (VoucherTypeKarmaMasterByIdResponse.isSuccess) {
            setGetByIdData(VoucherTypeKarmaMasterByIdResponse.data);
        } else if (VoucherTypeKarmaMasterByIdResponse.isError) {
            let response: any = VoucherTypeKarmaMasterByIdResponse?.error;
            alertMessage(response, "error");
        }
    }, [VoucherTypeKarmaMasterByIdResponse.isSuccess, VoucherTypeKarmaMasterByIdResponse.isError]);



    useEffect(() => {
        if (voucherFinanceMasterByIdResponse.isSuccess) {
            setGetByIdData(voucherFinanceMasterByIdResponse.data);
        } else if (voucherFinanceMasterByIdResponse.isError) {
            let response: any = voucherFinanceMasterByIdResponse?.error;
            alertMessage(response, "error");
        }
    }, [voucherFinanceMasterByIdResponse.isSuccess, voucherFinanceMasterByIdResponse.isError]);


    useEffect(() => {
        if (voucherKarmaMasterByIdResponse.isSuccess) {
            setGetByIdData(voucherKarmaMasterByIdResponse.data);
        } else if (voucherKarmaMasterByIdResponse.isError) {
            let response: any = voucherKarmaMasterByIdResponse?.error;
            alertMessage(response, "error");
        }
    }, [voucherKarmaMasterByIdResponse.isSuccess, voucherKarmaMasterByIdResponse.isError]);


    useEffect(() => {
        if (voucherParticipanMasterByIdResponse.isSuccess) {
            setGetByIdData(voucherParticipanMasterByIdResponse.data);
        } else if (voucherParticipanMasterByIdResponse.isError) {
            let response: any = voucherParticipanMasterByIdResponse?.error;
            alertMessage(response, "error");
        }
    }, [
        voucherParticipanMasterByIdResponse.isSuccess,
        voucherParticipanMasterByIdResponse.isError
    ]);


    useEffect(() => {
        if (partyCategoryMasterMasterByIdResponse.isSuccess) {
            setGetByIdData(partyCategoryMasterMasterByIdResponse.data);
        } else if (partyCategoryMasterMasterByIdResponse.isError) {
            let response: any = partyCategoryMasterMasterByIdResponse?.error;
            alertMessage(response, "error");
        }
    }, [
        partyCategoryMasterMasterByIdResponse.isSuccess,
        partyCategoryMasterMasterByIdResponse.isError
    ]);



    const handleBulkUpload = (e: any) => {

        const file = e.target.files[0];

        const fileName = e.target.files[0].name;
        const extension = fileName.lastIndexOf(".") + 1;
        const extFile = fileName.substr(extension, fileName.length).toLowerCase();

        if (extFile == "xlsx") {
            setFile(e.target.files[0]);
        } else {
            alertMessage("Only xlsx files are allowed!", "error");
        }
    };


    const handleBulkSave = () => {
        if (props.actionType === ACTION_TYPE.ADD_ACTION) {
            const formData = new FormData();
            if (file) {
                formData.append('file', file);
            }

            if (props.reportName === REPORT_NAME.VOUCHER_TYPE_MASTER_FINANCE) {
                bulkSaveVoucherTypeFinanceMaster({
                    payload: formData,
                    token: localUserObj?.token
                });
            } else if (props.reportName === REPORT_NAME.VOUCHER_TYPE_MASTER_KARMA) {
                bulkSaveVoucherTypeKarmaMaster({
                    payload: formData,
                    token: localUserObj?.token
                });
            }
            else if (props.reportName === REPORT_NAME.VOUCHER_FINANCE) {
                bulkSaveVoucherFinanceMaster({
                    payload: formData,
                    token: localUserObj?.token
                });
            }
            else if (props.reportName === REPORT_NAME.VOUCHER_KARMA) {
                bulkSaveVoucherKarmaMaster({
                    payload: formData,
                    token: localUserObj?.token
                });
            }
            else if (props.reportName === REPORT_NAME.VOUCHER_PARTICIPANT) {
                bulkSaveVoucherParticipanMaster({
                    payload: formData,
                    token: localUserObj?.token
                });
            }
            else if (props.reportName === REPORT_NAME.PARTY_CATEGORY_MASTER) {
                bulkSavePartyCategoryMaster({
                    payload: formData,
                    token: localUserObj?.token
                });
            }
        }
    }

    useEffect(() => {
        if (bulkSaveVoucherTypeFinanceMasterResponse.isSuccess) {
            const response: any = bulkSaveVoucherTypeFinanceMasterResponse.data;
            const payload = {
                tableName: REPORT_NAME.VOUCHER_TYPE_MASTER_FINANCE,
                operationType: "SAVE",
                newValueList: response,
            };

            logAuditBulk({
                token: localUserObj?.token,
                payload,
            });
            alertMessage("Voucher Type Master - Finance uploaded successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (bulkSaveVoucherTypeFinanceMasterResponse.isError) {
            const response: any = bulkSaveVoucherTypeFinanceMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [
        bulkSaveVoucherTypeFinanceMasterResponse.isSuccess,
        bulkSaveVoucherTypeFinanceMasterResponse.isError
    ]);



    // Bulk Save Voucher Finance
    useEffect(() => {
        if (bulkSaveVoucherFinanceMasterResponse.isSuccess) {
            const response: any = bulkSaveVoucherFinanceMasterResponse.data;
            const payload = {
                tableName: REPORT_NAME.VOUCHER_FINANCE,
                operationType: "SAVE",
                newValueList: response,
            };

            logAuditBulk({
                token: localUserObj?.token,
                payload,
            });
            alertMessage("Voucher Finance Master uploaded successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (bulkSaveVoucherFinanceMasterResponse.isError) {
            const response: any = bulkSaveVoucherFinanceMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [
        bulkSaveVoucherFinanceMasterResponse.isSuccess,
        bulkSaveVoucherFinanceMasterResponse.isError
    ]);

    // Bulk Save Voucher Karma
    useEffect(() => {
        if (bulkSaveVoucherKarmaMasterResponse.isSuccess) {
            const response: any = bulkSaveVoucherKarmaMasterResponse.data;
            const payload = {
                tableName: REPORT_NAME.VOUCHER_KARMA,
                operationType: "SAVE",
                newValueList: response,
            };

            logAuditBulk({
                token: localUserObj?.token,
                payload,
            });
            alertMessage("Voucher Karma Master uploaded successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (bulkSaveVoucherKarmaMasterResponse.isError) {
            const response: any = bulkSaveVoucherKarmaMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [
        bulkSaveVoucherKarmaMasterResponse.isSuccess,
        bulkSaveVoucherKarmaMasterResponse.isError
    ]);

    useEffect(() => {
        if (bulkSaveVoucherTypeKarmaMasterResponse.isSuccess) {
            const response: any = bulkSaveVoucherKarmaMasterResponse.data;
            const payload = {
                tableName: REPORT_NAME.VOUCHER_TYPE_MASTER_KARMA,
                operationType: "SAVE",
                newValueList: response,
            };

            logAuditBulk({
                token: localUserObj?.token,
                payload,
            });
            alertMessage("Voucher Type Master - Finance uploaded successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (bulkSaveVoucherTypeKarmaMasterResponse.isError) {
            const response: any = bulkSaveVoucherTypeKarmaMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [
        bulkSaveVoucherTypeKarmaMasterResponse.isSuccess,
        bulkSaveVoucherTypeKarmaMasterResponse.isError
    ]);


    useEffect(() => {
        if (bulkSaveVoucherParticipanMasterResponse.isSuccess) {
            const response: any = bulkSaveVoucherParticipanMasterResponse.data;
            const payload = {
                tableName: REPORT_NAME.VOUCHER_PARTICIPANT,
                operationType: "SAVE",
                newValueList: response,
            };

            logAuditBulk({
                token: localUserObj?.token,
                payload,
            });
            alertMessage("Voucher Participant Master uploaded successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (bulkSaveVoucherParticipanMasterResponse.isError) {
            const response: any = bulkSaveVoucherParticipanMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [
        bulkSaveVoucherParticipanMasterResponse.isSuccess,
        bulkSaveVoucherParticipanMasterResponse.isError
    ]);


    useEffect(() => {
        if (bulkSavePartyCategoryMasterResponse.isSuccess) {
            const response: any = bulkSavePartyCategoryMasterResponse.data;
            const payload = {
                tableName: REPORT_NAME.PARTY_CATEGORY_MASTER,
                operationType: "SAVE",
                newValueList: response,
            };

            logAuditBulk({
                token: localUserObj?.token,
                payload,
            });
            alertMessage("Party Category Master uploaded successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (bulkSavePartyCategoryMasterResponse.isError) {
            const response: any = bulkSavePartyCategoryMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [
        bulkSavePartyCategoryMasterResponse.isSuccess,
        bulkSavePartyCategoryMasterResponse.isError
    ]);


    useEffect(() => {
        if (findAllScenarioMastersResponse.isSuccess) {
            dispatch(setAllScenarioMasters(findAllScenarioMastersResponse));
        } else if (findAllScenarioMastersResponse.isError) {
            let response: any = findAllScenarioMastersResponse.error;
            alertMessage(response, "error");
        }
    }, [findAllScenarioMastersResponse.isSuccess, findAllScenarioMastersResponse.isError]);


    useEffect(() => {
        if (getAllVoucherTypeFinanceMasterResponse.isSuccess) {
            dispatch(setAllVoucherTypeFinanceMaster(getAllVoucherTypeFinanceMasterResponse));
        } else if (getAllVoucherTypeFinanceMasterResponse.isError) {
            let response: any = getAllVoucherTypeFinanceMasterResponse.error;
            alertMessage(response, "error");
        }
    }, [getAllVoucherTypeFinanceMasterResponse.isSuccess, getAllVoucherTypeFinanceMasterResponse.isError]);

    useEffect(() => {
        if (findAllPartyCategoryMasterResponse.isSuccess) {
            dispatch(setAllPartyCategoryMaster(findAllPartyCategoryMasterResponse));
        } else if (findAllPartyCategoryMasterResponse.isError) {
            let response: any = findAllPartyCategoryMasterResponse.error;
            alertMessage(response, "error");
        }
    }, [findAllPartyCategoryMasterResponse.isSuccess, findAllPartyCategoryMasterResponse.isError]);



    useEffect(() => {
        if (getAllVoucherTypeKarmaMasterResponse.isSuccess) {
            dispatch(setAllVoucherTypeKarmaMaster(getAllVoucherTypeKarmaMasterResponse));
        } else if (getAllVoucherTypeKarmaMasterResponse.isError) {
            let response: any = getAllVoucherTypeKarmaMasterResponse.error;
            alertMessage(response, "error");
        }
    }, [getAllVoucherTypeKarmaMasterResponse.isSuccess, getAllVoucherTypeKarmaMasterResponse.isError]);


    useEffect(() => {
        if (findAllAccountMasterResponse.isSuccess) {
            dispatch(setAllAccountMaster(findAllAccountMasterResponse));
        } else if (findAllAccountMasterResponse.isError) {
            let response: any = findAllAccountMasterResponse.error;
            alertMessage(response, "error");
        }
    }, [findAllAccountMasterResponse.isSuccess, findAllAccountMasterResponse.isError]);


    useEffect(() => {
        if (findAllScripturalReferencesResponse.isSuccess) {
            dispatch(setAllScripturalReferences(findAllScripturalReferencesResponse));
        } else if (findAllScripturalReferencesResponse.isError) {
            let response: any = findAllScripturalReferencesResponse.error;
            alertMessage(response, "error");
        }
    }, [findAllScripturalReferencesResponse.isSuccess, findAllScripturalReferencesResponse.isError]);


    useEffect(() => {
        if (findAllVoucherFinanceResponse.isSuccess) {
            dispatch(setAllVoucherFinance(findAllVoucherFinanceResponse.data));
        } else if (findAllVoucherFinanceResponse.isError) {
            let response: any = findAllVoucherFinanceResponse.error;
            alertMessage(response, "error");
        }
    }, [findAllVoucherFinanceResponse.isSuccess, findAllVoucherFinanceResponse.isError]);



    useEffect(() => {
        if (findAllMemberMasterResponse.isSuccess) {
            dispatch(setMemberMasterList(findAllMemberMasterResponse));
        } else if (findAllMemberMasterResponse.isError) {
            let response: any = findAllMemberMasterResponse.error;
            alertMessage(response, "error");
        }
    }, [findAllMemberMasterResponse.isSuccess, findAllMemberMasterResponse.isError]);


    return (
        <>
            <Modal
                show={props.show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                // dialogClassName={"modal-90w"}
                {...(
                    props.reportName === REPORT_NAME.USER_SUBSCRIBER || props.reportName === REPORT_NAME.USER_GROUP
                        ? { dialogClassName: "modal-90w" }
                        : { size: "lg" } // default to lg for all others
                )}
            >
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold text-accent" style={{ fontSize: "1rem" }}>
                        {props.actionType === ACTION_TYPE.ADD_ACTION ? "Add" : "Update"}{" "}
                        {props.reportName}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {
                        saveVoucherTypeFinanceMasterResponse.isLoading ||
                            saveVoucherTypeKarmaMasterResponse.isLoading ||
                            saveVoucherFinanceMasterResponse.isLoading ||
                            saveVoucherKarmaMasterResponse.isLoading ||
                            saveVoucherParticipanMasterResponse.isLoading ||

                            bulkSaveVoucherTypeFinanceMasterResponse.isLoading ||
                            bulkSaveVoucherTypeKarmaMasterResponse.isLoading ||
                            bulkSaveVoucherFinanceMasterResponse.isLoading ||
                            bulkSaveVoucherKarmaMasterResponse.isLoading ||
                            bulkSaveVoucherParticipanMasterResponse.isLoading ||

                            updateVoucherTypeFinanceMasterResponse.isLoading ||
                            updateVoucherTypeKarmaMasterResponse.isLoading ||
                            updateVoucherFinanceMasterResponse.isLoading ||
                            updateVoucherKarmaMasterResponse.isLoading ||
                            updateVoucherParticipanMasterResponse.isLoading ||

                            voucherTypeFinanceMasterByIdResponse.isLoading ||
                            VoucherTypeKarmaMasterByIdResponse.isLoading ||
                            voucherFinanceMasterByIdResponse.isLoading ||
                            voucherKarmaMasterByIdResponse.isLoading ||
                            voucherParticipanMasterByIdResponse.isLoading ||

                            findAllScenarioMastersResponse.isLoading ||
                            getAllVoucherTypeFinanceMasterResponse.isLoading ||
                            getAllVoucherTypeKarmaMasterResponse.isLoading ||
                            findAllAccountMasterResponse.isLoading ||
                            findAllScripturalReferencesResponse.isLoading ||
                            findAllVoucherFinanceResponse.isLoading ||
                            findAllMemberMasterResponse.isLoading ? (
                            <Loading />
                        ) : (
                            ""
                        )
                    }


                    {props.actionType === ACTION_TYPE.ADD_ACTION && (
                        <ul className="nav nav-tabs mb-3" role="tablist">
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'manual' ? 'active text-accent' : 'text-secondary'}`}
                                    onClick={() => setActiveTab('manual')}
                                >
                                    Manual Entry
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'bulk' ? 'active text-accent' : 'text-secondary'}`}
                                    onClick={() => setActiveTab('bulk')}
                                >
                                    Bulk Upload
                                </button>
                            </li>
                        </ul>
                    )}

                    {activeTab === "manual" && (
                        <Formik
                            enableReinitialize={true}
                            initialValues={
                                props.reportName === REPORT_NAME.VOUCHER_FINANCE
                                    ? {
                                        id: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.id || "" : "",
                                        voucherTypeCode: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.voucherTypeCode || "" : "",
                                        amount: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.amount || "" : "",
                                        partyCategoryId: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.partyCategoryId || "" : "",
                                        party: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.party || "" : "",
                                        narration: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.narration || "" : "",
                                        approvalStatus: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.approvalStatus || "" : "",
                                        approvedBy: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.approvedBy || "" : "",
                                        approvalDate: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.approvalDate || "" : "",
                                        parentVoucherCode: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.parentVoucherId || "" : "",
                                        projectTag: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.projectTag || "" : "",
                                        accountNameDebit: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.accountNameDebit || "" : "",
                                        accountNameCredit: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.accountNameCredit || "" : "",
                                        googleDriveLink: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.googleDriveLink || "" : "",
                                        isActive: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.isActive ?? true : true,
                                    }
                                    : props.reportName === REPORT_NAME.VOUCHER_KARMA
                                        ? {
                                            id: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.id || "" : "",
                                            voucherTypeCode: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.voucherTypeCode || "" : "",
                                            scenarioId: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.scenarioId || "" : "",
                                            accountId: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.accountId || "" : "",
                                            debit: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.debit || "" : "",
                                            credit: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.credit || "" : "",
                                            tokenValue: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.tokenValue || "" : "",
                                            agent: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.agent || "" : "",
                                            assessmentOutcome: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.assessmentOutcome || "" : "",
                                            improvementSuggestion: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.improvementSuggestion || "" : "",
                                            aiConfidenceScore: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.aiConfidenceScore || "" : "",
                                            scripturalReferenceId: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.scripturalReferenceId || "" : "",
                                            parentVoucherId: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.parentVoucherId || "" : "",
                                            purposeCode: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.purposeCode || "" : "",
                                            validityDate: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.validityDate || "" : "",
                                            projectTag: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.projectTag || "" : "",
                                            isActive: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.isActive ?? true : true,
                                            scriptureVerseName: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.scriptureVerseName || "" : "",
                                            verseExplanation: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.verseExplanation || "" : "",
                                            accountCode: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.accountCode || "" : "",
                                            scenarioCode: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.scenarioCode || "" : "",
                                            scripturalReferenceCode: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.scripturalReferenceCode || "" : "",

                                        }
                                        : props.reportName === REPORT_NAME.VOUCHER_PARTICIPANT
                                            ? {
                                                id: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.id || "" : "",
                                                voucherId: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.voucherId ?? 0 : 0,
                                                memberId: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.memberId ?? 0 : 0,
                                                role: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.role || "" : "",
                                                memberCode: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.memberCode || "" : "",
                                                isActive: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.isActive ?? true : true,
                                            }
                                            : props.reportName === REPORT_NAME.PARTY_CATEGORY_MASTER
                                                ? {
                                                    id: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.id || "" : "",
                                                    code: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.code || "" : "",
                                                    name: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.name || "" : "",
                                                    description: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.description || "" : "",
                                                    isActive: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.isActive ?? true : true,
                                                }
                                                : {
                                                    name: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.name || "" : "",
                                                    description: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.description || "" : "",
                                                    isActive: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.isActive ?? true : true,
                                                }
                            }
                            onSubmit={handleSubmit}
                        >
                            {({ values, setFieldValue, handleChange }) => (
                                <Form>
                                    <div>
                                        {props.reportName === REPORT_NAME.VOUCHER_FINANCE ? (
                                            <div className="row g-3">
                                                {/* Left Column */}
                                                <div className="col-12 col-md-6">
                                                    {/* Voucher Type Code */}
                                                    <label className="form-label">
                                                        Voucher Type Code <span style={{ color: "red" }}>*</span>
                                                    </label>
                                                    <select
                                                        className="form-select form-select-sm"
                                                        name="voucherTypeCode"
                                                        value={values.voucherTypeCode}
                                                        onChange={(e) => setFieldValue("voucherTypeCode", e.target.value)}
                                                        required
                                                    >
                                                        <option value="">Select Voucher Type</option>
                                                        {allVoucherTypeFinanceMasterData.map((item: any, idx: number) => (
                                                            <option key={idx} value={item.id}>
                                                                {item.id} - {item.name}
                                                            </option>
                                                        ))}
                                                    </select>

                                                    {/* Amount */}
                                                    <label className="form-label mt-3">
                                                        Amount <span style={{ color: "red" }}>*</span>
                                                    </label>
                                                    <input
                                                        className="form-control form-control-sm"
                                                        type="text"
                                                        name="amount"
                                                        value={values.amount}
                                                        onChange={handleChange}
                                                        required
                                                    />

                                                    <label className="form-label">
                                                        Party Category <span style={{ color: "red" }}>*</span>
                                                    </label>
                                                    <select
                                                        className="form-select form-select-sm"
                                                        name="partyCategoryId"
                                                        value={values.partyCategoryId}
                                                        onChange={(e) => setFieldValue("partyCategoryId", e.target.value)}
                                                        required
                                                    >
                                                        <option value="">Select Party Category</option>
                                                        {allPartyCategoryData?.map((item: any, idx: number) => (
                                                            <option key={idx} value={item.id}>
                                                                {item.id} - {item.name}
                                                            </option>
                                                        ))}
                                                    </select>

                                                    <label className="form-label mt-3">
                                                        Account Name Debit
                                                    </label>
                                                    <select
                                                        className="form-select form-select-sm"
                                                        name="accountNameDebit"
                                                        value={values.accountNameDebit}
                                                        onChange={(e) => setFieldValue("accountNameDebit", e.target.value)}
                                                    >
                                                        <option value="">Select Account Name Debit</option>
                                                        {allAccountMasterData.map((item: any, idx: number) => (
                                                            <option key={idx} value={item.id}>
                                                                {item.id} - {item.accountName}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    <label className="form-label mt-3">
                                                        Account Name Credit
                                                    </label>
                                                    <select
                                                        className="form-select form-select-sm"
                                                        name="accountNameCredit"
                                                        value={values.accountNameCredit}
                                                        onChange={(e) => setFieldValue("accountNameCredit", e.target.value)}
                                                    >
                                                        <option value="">Select Account Name Credit</option>
                                                        {allAccountMasterData.map((item: any, idx: number) => (
                                                            <option key={idx} value={item.id}>
                                                                {item.id} - {item.accountName}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    {/* Narration */}
                                                    <label className="form-label mt-3">Narration</label>
                                                    <input
                                                        className="form-control form-control-sm"
                                                        type="text"
                                                        name="narration"
                                                        value={values.narration}
                                                        required
                                                        onChange={(e) => setFieldValue("narration", e.target.value)}
                                                    />
                                                    <label className="form-label mt-3">Google Drive Link</label>
                                                    <input
                                                        className="form-control form-control-sm"
                                                        type="text"
                                                        name="googleDriveLink"
                                                        value={values.googleDriveLink}
                                                        onChange={(e) => setFieldValue("googleDriveLink", e.target.value)}
                                                        placeholder="Enter Google Drive URL"
                                                    />

                                                </div>

                                                {/* Right Column */}
                                                <div className="col-12 col-md-6">
                                                    {/* Project Tag */}
                                                    <label className="form-label">Project Tag</label>
                                                    <input
                                                        className="form-control form-control-sm"
                                                        type="text"
                                                        name="projectTag"
                                                        value={values.projectTag}
                                                        required
                                                        onChange={(e) => setFieldValue("projectTag", e.target.value)}
                                                    />
                                                    <label className="form-label mt-3">Party</label>
                                                    <input
                                                        className="form-control form-control-sm"
                                                        type="text"
                                                        name="party"
                                                        value={values.party}
                                                        required
                                                        onChange={(e) => setFieldValue("party", e.target.value)}
                                                    />
                                                    {/* Approval Status */}
                                                    <label className="form-label">Approval Status</label>
                                                    <input
                                                        className="form-control form-control-sm"
                                                        type="text"
                                                        name="approvalStatus"
                                                        value={values.approvalStatus}
                                                        required
                                                        onChange={(e) => setFieldValue("approvalStatus", e.target.value)}
                                                    />

                                                    {/* Approved By */}
                                                    <label className="form-label mt-3">Approved By</label>
                                                    <input
                                                        className="form-control form-control-sm"
                                                        type="text"
                                                        name="approvedBy"
                                                        value={values.approvedBy}
                                                        onChange={(e) => setFieldValue("approvedBy", e.target.value)}
                                                    />

                                                    {/* Approval Date */}
                                                    <label className="form-label mt-3">Approval Date</label>

                                                    <DatePicker
                                                        className="w-100"
                                                        format="YYYY-MM-DD"
                                                        value={values.approvalDate ? dayjs(values.approvalDate, "YYYY-MM-DD") : null}
                                                        onChange={(date) =>
                                                            setFieldValue(
                                                                "approvalDate",
                                                                date ? date.format("YYYY-MM-DD") : ""
                                                            )
                                                        }
                                                        getPopupContainer={(trigger) =>
                                                            (trigger.parentNode as HTMLElement) || document.body
                                                        }
                                                    />


                                                    <label className="form-label mt-3">
                                                        Parent Voucher Code
                                                    </label>
                                                    <input
                                                        className="form-control form-control-sm"
                                                        type="text"
                                                        name="parentVoucherCode"
                                                        value={values.parentVoucherCode}
                                                        onChange={(e) => setFieldValue("parentVoucherCode", e.target.value)}
                                                    />


                                                </div>
                                            </div>
                                        ) : props.reportName === REPORT_NAME.VOUCHER_KARMA ? (
                                            <div className="row g-3">
                                                {/* Left Column */}
                                                <div className="col-12 col-md-6">
                                                    {/* Voucher Type Code */}
                                                    <label className="form-label">
                                                        Voucher Type Code <span style={{ color: "red" }}>*</span>
                                                    </label>
                                                    <select
                                                        className="form-select form-select-sm"
                                                        name="voucherTypeCode"
                                                        value={values.voucherTypeCode}
                                                        onChange={(e) => setFieldValue("voucherTypeCode", e.target.value)}
                                                        required
                                                    >
                                                        <option value="">Select Voucher Type</option>
                                                        {allVoucherTypeKarmaMasterData.map((item: any, idx: number) => (
                                                            <option key={idx} value={item.id}>
                                                                {item.id} - {item.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    {/* 
                                                    <label className="form-label">
                                                        Voucher Type Code <span style={{ color: "red" }}>*</span>
                                                    </label>
                                                    <select
                                                        className="form-select form-select-sm"
                                                        name="voucherTypeCode"
                                                        value={values.voucherTypeCode}
                                                        onChange={(e) => setFieldValue("voucherTypeCode", e.target.value)}
                                                        required
                                                    >
                                                        <option value="">Select Voucher Type</option>
                                                        {allVoucherTypeFinanceMasterData.map((item: any, idx: number) => (
                                                            <option key={idx} value={item.id}>
                                                                {item.id} - {item.name}
                                                            </option>
                                                        ))}
                                                    </select> */}


                                                    {/* Scenario */}
                                                    <label className="form-label mt-3">
                                                        Scenario Id
                                                    </label>
                                                    <select
                                                        className="form-select form-select-sm"
                                                        name="scenarioId"
                                                        value={values.scenarioId}
                                                        onChange={(e) => setFieldValue("scenarioId", e.target.value)}
                                                    >
                                                        <option value="">Select Scenario</option>
                                                        {allScenarioMasterData.map((item: any, idx: number) => (
                                                            <option key={idx} value={item.id}>
                                                                {item.id} - {item.scenarioType}
                                                            </option>
                                                        ))}
                                                    </select>

                                                    {/* Account Code */}
                                                    <label className="form-label mt-3">Account Id</label>
                                                    <select
                                                        className="form-select form-select-sm"
                                                        name="accountId"
                                                        value={values.accountId}
                                                        onChange={(e) => setFieldValue("accountId", e.target.value)}
                                                    >
                                                        <option value="">Select Account</option>
                                                        {allAccountMasterData.map((item: any, idx: number) => (
                                                            <option key={idx} value={item.id}>
                                                                {item.id} - {item.accountName}
                                                            </option>
                                                        ))}
                                                    </select>

                                                    <label className="form-label mt-3">Scriptural Reference Id</label>
                                                    <select
                                                        className="form-select form-select-sm"
                                                        name="scripturalReferenceId"
                                                        value={values.scripturalReferenceId}
                                                        onChange={(e) => setFieldValue("scripturalReferenceId", e.target.value)}
                                                    >
                                                        <option value="">Select Scriptural Reference</option>
                                                        {allScripturalReferencesData.map((item: any, idx: number) => (
                                                            <option key={idx} value={item.id}>
                                                                {item.id} - {item.context}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    {/* Parent Voucher ID */}
                                                    <label className="form-label mt-3">
                                                        Parent Voucher Id
                                                    </label>
                                                    <select
                                                        className="form-select form-select-sm"
                                                        name="parentVoucherId"
                                                        value={values.parentVoucherId}
                                                        onChange={(e) => setFieldValue("parentVoucherId", e.target.value)}
                                                    >
                                                        <option value="">Select Parent Voucher</option>
                                                        {allVoucherFinanceData.map((item: any, idx: number) => (
                                                            <option key={idx} value={item.id}>
                                                                {item.id} - {item.party} - {item.narration} -₹{item.amount}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    {/* Debit */}
                                                    <label className="form-label mt-3">Debit</label>
                                                    <input
                                                        className="form-control form-control-sm"
                                                        type="text"
                                                        name="debit"
                                                        value={values.debit}
                                                        onChange={(e) => setFieldValue("debit", e.target.value)}
                                                    />

                                                    {/* Credit */}
                                                    <label className="form-label mt-3">Credit</label>
                                                    <input
                                                        className="form-control form-control-sm"
                                                        type="text"
                                                        name="credit"
                                                        value={values.credit}
                                                        onChange={(e) => setFieldValue("credit", e.target.value)}
                                                    />

                                                    {/* Account ID (Text Field) */}
                                                    <label className="form-label mt-3">Account Code</label>
                                                    <input
                                                        className="form-control form-control-sm"
                                                        type="text"
                                                        name="accountCode"
                                                        value={values.accountCode}
                                                        onChange={(e) => setFieldValue("accountCode", e.target.value)}
                                                    />

                                                    {/* Scenario ID (Text Field) */}
                                                    <label className="form-label mt-3">Scenario Code</label>
                                                    <input
                                                        className="form-control form-control-sm"
                                                        type="text"
                                                        name="scenarioCode"
                                                        value={values.scenarioCode}
                                                        onChange={(e) => setFieldValue("scenarioCode", e.target.value)}
                                                    />

                                                    {/* Scriptural Reference ID (Text Field) */}
                                                    <label className="form-label mt-3">Scriptural Reference Code</label>
                                                    <input
                                                        className="form-control form-control-sm"
                                                        type="text"
                                                        name="scripturalReferenceCode"
                                                        value={values.scripturalReferenceCode}
                                                        onChange={(e) => setFieldValue("scripturalReferenceCode", e.target.value)}
                                                    />


                                                </div>

                                                {/* Right Column */}
                                                <div className="col-12 col-md-6">
                                                    {/* Token Value */}
                                                    <label className="form-label">Token Value</label>
                                                    <input
                                                        className="form-control form-control-sm"
                                                        type="text"
                                                        name="tokenValue"
                                                        value={values.tokenValue}
                                                        onChange={(e) => setFieldValue("tokenValue", e.target.value)}
                                                    />

                                                    <label className="form-label mt-2">Purpose Code</label>
                                                    <input
                                                        className="form-control form-control-sm"
                                                        type="text"
                                                        name="purposeCode"
                                                        value={values.purposeCode}
                                                        onChange={(e) => setFieldValue("purposeCode", e.target.value)}
                                                    />

                                                    {/* Agent */}
                                                    <label className="form-label mt-3">Agent</label>
                                                    <input
                                                        className="form-control form-control-sm"
                                                        type="text"
                                                        name="agent"
                                                        value={values.agent}
                                                        onChange={(e) => setFieldValue("agent", e.target.value)}
                                                    />


                                                    {/* Assessment Outcome */}
                                                    <label className="form-label mt-3">Assessment Outcome</label>
                                                    <input
                                                        className="form-control form-control-sm"
                                                        type="text"
                                                        name="assessmentOutcome"
                                                        value={values.assessmentOutcome}
                                                        onChange={(e) => setFieldValue("assessmentOutcome", e.target.value)}
                                                    />

                                                    {/* Improvement Suggestion */}
                                                    <label className="form-label mt-3">Improvement Suggestion</label>
                                                    <input
                                                        className="form-control form-control-sm"
                                                        type="text"
                                                        name="improvementSuggestion"
                                                        value={values.improvementSuggestion}
                                                        onChange={(e) => setFieldValue("improvementSuggestion", e.target.value)}
                                                    />

                                                    {/* AI Confidence Score */}
                                                    <label className="form-label mt-3">AI Confidence Score</label>
                                                    <input
                                                        className="form-control form-control-sm"
                                                        type="text"
                                                        name="aiConfidenceScore"
                                                        value={values.aiConfidenceScore}
                                                        onChange={(e) => setFieldValue("aiConfidenceScore", e.target.value)}
                                                    />

                                                    {/* Validity Date */}
                                                    <label className="form-label mt-3">Validity Date</label>
                                                    <DatePicker
                                                        className="w-100"
                                                        format="YYYY-MM-DD"
                                                        value={values.validityDate ? dayjs(values.validityDate, "YYYY-MM-DD") : null}
                                                        onChange={(date) =>
                                                            setFieldValue(
                                                                "validityDate",
                                                                date ? date.format("YYYY-MM-DD") : ""
                                                            )
                                                        }
                                                        getPopupContainer={(trigger) =>
                                                            (trigger.parentNode as HTMLElement) || document.body
                                                        }
                                                    />
                                                    {/* Project Tag */}
                                                    <label className="form-label mt-3">Project Tag</label>
                                                    <input
                                                        className="form-control form-control-sm"
                                                        type="text"
                                                        name="projectTag"
                                                        value={values.projectTag}
                                                        onChange={(e) => setFieldValue("projectTag", e.target.value)}
                                                    />

                                                    {/* Scripture Verse Name */}
                                                    <label className="form-label mt-3">Scripture Verse Name</label>
                                                    <input
                                                        className="form-control form-control-sm"
                                                        type="text"
                                                        name="scriptureVerseName"
                                                        value={values.scriptureVerseName}
                                                        onChange={(e) => setFieldValue("scriptureVerseName", e.target.value)}
                                                    />

                                                    {/* Verse Explanation */}
                                                    <label className="form-label mt-3">Verse Explanation</label>
                                                    <textarea
                                                        className="form-control form-control-sm"
                                                        name="verseExplanation"
                                                        value={values.verseExplanation}
                                                        onChange={(e) => setFieldValue("verseExplanation", e.target.value)}
                                                        rows={3}
                                                    />

                                                </div>
                                            </div>
                                        ) : props.reportName === REPORT_NAME.VOUCHER_PARTICIPANT ? (
                                            <div >
                                                {/* Voucher */}
                                                <label className="form-label me-2">Voucher <span style={{ color: "red" }}>*</span></label>
                                                <select
                                                    className="form-select form-select-sm"
                                                    name="voucherId"
                                                    value={values.voucherId}
                                                    onChange={(e) => setFieldValue("voucherId", e.target.value)}
                                                    required
                                                >
                                                    <option value="">Select Voucher</option>
                                                    {allVoucherFinanceData && allVoucherFinanceData.map((item: any, idx: any) => (
                                                        <option key={idx} value={item.id}>
                                                            {item.id} - {item.party} - {item.narration} -₹{item.amount}
                                                        </option>
                                                    ))}
                                                </select>

                                                {/* Member */}
                                                <label className="form-label me-2">Member Id</label>
                                                <select
                                                    className="form-select form-select-sm"
                                                    name="memberId"
                                                    value={values.memberId}
                                                    onChange={(e) => setFieldValue("memberId", e.target.value)}
                                                >
                                                    <option value="">Select Member</option>
                                                    {allMemberMasterData && allMemberMasterData.map((item: any, idx: any) => (
                                                        <option key={idx} value={item.id}>
                                                            {item.id} - {item.memberName}
                                                        </option>
                                                    ))}
                                                </select>
                                                <label className="form-label mt-3">Member Code</label>
                                                <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    name="memberCode"
                                                    value={values.memberCode}
                                                    onChange={(e) => setFieldValue("memberCode", e.target.value)}
                                                />

                                                {/* Role */}
                                                <label className="form-label me-2">Role </label>
                                                <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    name="role"
                                                    value={values.role}
                                                    onChange={(e) => setFieldValue("role", e.target.value)}
                                                />
                                            </div>

                                        ) : props.reportName === REPORT_NAME.PARTY_CATEGORY_MASTER ? (
                                            <div>
                                                <label className="form-label mt-3">Code</label>
                                                <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    name="code"
                                                    value={values.code}
                                                    onChange={(e) => setFieldValue("code", e.target.value)}
                                                />

                                                <label className="form-label mt-3">Name</label>
                                                <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    name="name"
                                                    value={values.name}
                                                    onChange={(e) => setFieldValue("name", e.target.value)}
                                                />

                                                <label className="form-label mt-3">Description</label>
                                                <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    name="description"
                                                    value={values.description}
                                                    onChange={(e) => setFieldValue("description", e.target.value)}
                                                />

                                            </div>
                                        ) :

                                            (
                                                <div>
                                                    {/* Default case */}
                                                    <label className="form-label">
                                                        Name <span style={{ color: "red" }}>*</span>
                                                    </label>
                                                    <input
                                                        className="form-control form-control-sm"
                                                        type="text"
                                                        name="name"
                                                        value={values.name}
                                                        onChange={(e) => setFieldValue("name", e.target.value)}
                                                        required
                                                    />

                                                    <label className="form-label mt-3">Description</label>
                                                    <textarea
                                                        className="form-control form-control-sm"
                                                        name="description"
                                                        value={values.description}
                                                        required
                                                        onChange={(e) => setFieldValue("description", e.target.value)}
                                                    />
                                                </div>
                                            )}
                                    </div>
                                    <div className="d-flex flex-row justify-content-center">
                                        <button
                                            type="submit"
                                            className={`btn btn-primary btn-block mt-3 mx-2 btn-width bg-accent`}
                                        >
                                            {props.actionType === ACTION_TYPE.ADD_ACTION ? "Save" : "Update"}
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-secondary btn-block mt-3 mx-2 btn-width"
                                            onClick={handleClose}
                                        >
                                            Close
                                        </button>
                                    </div>
                                </Form>
                            )}
                        </Formik>

                    )}
                    {activeTab === "bulk" && (
                        <div className="border p-3 rounded">
                            <div className="mb-3">
                                <label htmlFor="xlsxUpload" className="form-label">
                                    Upload .xlsx File <span className="text-danger">*</span>
                                </label>
                                <input
                                    className="form-control"
                                    type="file"
                                    accept=".xlsx"
                                    id="xlsxUpload"
                                    onChange={handleBulkUpload}
                                />
                            </div>
                            <a
                                href={`/templates/${props.reportName === REPORT_NAME.VOUCHER_TYPE_MASTER_FINANCE
                                    ? "VOUCHER_TYPE_MASTER_FINANCE"
                                    : props.reportName === REPORT_NAME.VOUCHER_TYPE_MASTER_KARMA
                                        ? "VOUCHER_TYPE_MASTER_KARMA"
                                        : props.reportName === REPORT_NAME.VOUCHER_FINANCE
                                            ? "VOUCHER_FINANCE"
                                            : props.reportName === REPORT_NAME.VOUCHER_KARMA
                                                ? "VOUCHER_KARMA"
                                                : props.reportName === REPORT_NAME.VOUCHER_PARTICIPANT
                                                    ? "VOUCHER_PARTICIPANT"
                                                    : props.reportName === REPORT_NAME.PARTY_CATEGORY_MASTER
                                                        ? "PARTY_CATEGORY_MASTER"
                                                        : ""
                                    }.xlsx`}
                                download
                                className="btn btn-outline-secondary"
                            >
                                Download Sample .xlsx Template
                            </a>
                            <button
                                className="btn btn-primary mx-2 bg-accent"
                                onClick={handleBulkSave}
                                disabled={!file}
                            >
                                Save
                            </button>
                        </div>
                    )}

                </Modal.Body>
            </Modal >
        </>
    );

};

export default VoucherTransactionReportData